import { DateTime } from './date-time';

/** A `YYYY-MM-DD` day moved by whole years: 29 February lands on 28 February in a year with no leap day. */
export const addYearsToDateString = (isoDate: string, years: number): string =>
	DateTime.fromDateString(isoDate).addYears(years).toISODateString();

/** The local day of `now` as `YYYY-MM-DD`. */
export const todayDateString = (now = new Date()): string => DateTime.fromDate(now).toISODateString();
